import { filterCapitalize } from "@/filters/capitalize";
import { ConfirmModel } from "../components/popup/Confirm";
import i18n from "@/plugins/i18n";

export class DoubleConfirm {
  show!: boolean;
  hasPermission!: boolean;
  message?: string;

  static async Process(
    doubleConfirm: DoubleConfirm | null,
    popup: (confirmModel: ConfirmModel) => Promise<unknown>,
    action: () => Promise<unknown>,
    successAction?: () => Promise<unknown>
  ): Promise<void> {
    if (doubleConfirm?.show) {
      const buttons = doubleConfirm.hasPermission
        ? [
            {
              text: filterCapitalize(i18n.t("cancel")),
              color: "warning",
              value: false,
              outlined: true,
            },
            {
              text: filterCapitalize(i18n.t("confirm")),
              color: "warning",
              value: true,
            },
          ]
        : [
            {
              text: filterCapitalize(i18n.t("close")),
              color: "warning",
              value: false,
            },
          ];

      const secondConfirm = new ConfirmModel(
        doubleConfirm.message ?? "",
        filterCapitalize(filterCapitalize(i18n.t("warning"))),
        buttons
      );

      const isConfirmed = await popup(secondConfirm);

      if (isConfirmed) {
        await action();
        if (successAction) await successAction();
      }
    } else if (successAction) await successAction();
  }
}
